import http from '../APIs/olonaTeams'

export default class FormAPI {
    // fiche 
  public createFiche = (data: any, token: any) => http.post('/fiche', data, token)

  public deleteFiche = (id: string | number, token: any) => http.delete(`/fiche/${id}`, token)

  public updateFiche = (id: string | number, data: any, token: any) => http.put(`/fiche/${id}`, data, token)
}